import React, {useEffect, useState} from 'react';
import {
    deleteConfigAPI,
    getConfigAPI,
    getServersAPI,
    getServersListAPI,
    newConfigAPI,
    newPremiumConfigAPI,
    getVpnSubscriptionAPI,
    ensureVpnSubscriptionAPI,
} from "../api";
import nid from "../servers/nid.png";
import itali from "../servers/itali.png";
import polsh from "../servers/polsh.png";
import kaz from "../servers/kaz.png";
import latvia from "../servers/latvia.png";
import tur from "../servers/tur.png";
import rus from "../servers/rus.png";
import usa from "../servers/usa.png";
import japan from "../servers/japan.png";
import spain from "../servers/spain.png";
import france from "../servers/france.png";
import germany from "../servers/germany.png";
import wireguard from "../servers/wireguard.png";
import amneziaWG from "../servers/amneziaWG.png";
import vless from "../servers/vless.png";
import classes from "../vpn.module.css";
import {CSSTransition} from "react-transition-group";
import Loading from "../../../common/loading/loading";
import Header from "../header/header";

const Vpn = ({client, getClient, openAddBalance, setOpenAddBalance}) => {
    const [notification, setNotification] = useState('')
    const [loading, setLoading] = useState(false)
    const [servers, setServers] = useState([[],[]])
    const [selectedServer, setSelectedServer] = useState(null)
    const [openServers, setOpenServers] = useState(false)
    const [myServers, setMyServers] = useState([])
    const [deleteConfigOpen, setDeleteConfigOpen] = useState(null)
    const [premiumConfirmOpen, setPremiumConfirmOpen] = useState(false)
    const [premiumConfirmOpt, setPremiumConfirmOpt] = useState(null)
    const [selectPlatform, setSelectPlatform] = useState(0)
    const [vpnSub, setVpnSub] = useState({ exists: false, url: null, locations: [] })
    const [subBusy, setSubBusy] = useState(false)

    async function getServersList(){
        setLoading(true)
        const res = await getServersListAPI()
        setMyServers(res)
        setLoading(false)
    }


    async function getServers(){
        setLoading(true)
        const res = await getServersAPI()
        setSelectedServer(res[0] || [])
        setServers(res)
        setLoading(false)
    }

    async function loadVpnSub(){
        const sub = await getVpnSubscriptionAPI()
        setVpnSub(sub || { exists: false, url: null, locations: [] })
    }

    useEffect(()=>{
        getServers()
        getServersList()
        loadVpnSub()
    },[])


    useEffect(()=>{
        if(notification !== '')
            setTimeout(()=>{setNotification('')},3000)
    },[notification])

    useEffect(() => {
            setSelectedServer(servers[selectPlatform] || [])
    }, [selectPlatform, servers]);

    async function onEnsureVless(){
        if(client?.balance <= 0 && !(client?.premium === true || String(client?.tariff_name || '').toUpperCase() === 'VIP')){
            setNotification('Ваш баланс равен 0. Пополните пожалуйста счет')
            return
        }
        setSubBusy(true)
        try{
            const sub = await ensureVpnSubscriptionAPI()
            setVpnSub(sub || { exists: true, url: sub?.url, locations: sub?.locations || [] })
            setNotification(sub?.exists ? 'VLESS-подписка готова' : 'Подписка получена')
            if(sub?.url && navigator?.clipboard?.writeText){
                try{ await navigator.clipboard.writeText(sub.url) }catch(_){ /* ignore */ }
            }
        }catch(err){
            setNotification(err?.message || 'Не удалось получить подписку')
        }finally{
            setSubBusy(false)
        }
    }

    async function onCopyVless(){
        if(!vpnSub?.url){
            await onEnsureVless()
            return
        }
        try{
            await navigator.clipboard.writeText(vpnSub.url)
            setNotification('Ссылка подписки скопирована')
        }catch(_){
            setNotification('Скопируйте ссылку вручную из чата')
        }
    }

    async function newConfig(country){
        const vip = client?.premium === true || String(client?.tariff_name || '').toUpperCase() === 'VIP'

        if(country?.is_premium){
            if(vip){
                setNotification('Premium-серверы недоступны для вашего тарифа')
                setOpenServers(false)
                return
            }
            if(client.balance <= 0){
                setNotification('Ваш баланс равен 0. Пополните пожалуйста счет')
                setOpenServers(false)
                return
            }
            setPremiumConfirmOpt(country)
            setPremiumConfirmOpen(true)
            return
        }

        if(vip || client.balance > 0){
            setLoading(true)
            await newConfigAPI(country)
            setLoading(false)
            setNotification('Файлик с конфигурацией отправлен Вам в чат')
            setOpenServers(false)
            await getServersList()
        }else{
            setNotification('Ваш баланс равен 0. Пополните пожалуйста счет')
            setOpenServers(false)
        }
    }

    async function confirmPremiumConfig(){
        if(!premiumConfirmOpt) return
        const opt = premiumConfirmOpt
        setPremiumConfirmOpen(false)
        setPremiumConfirmOpt(null)

        setLoading(true)
        await newPremiumConfigAPI(opt)
        setLoading(false)

        setNotification('Файлик с конфигурацией отправлен Вам в чат')
        setOpenServers(false)
        await getServersList()
    }

    async function getConfig(config){
        setNotification('Файлик с конфигурацией отправлен Вам в чат')
        await getConfigAPI(config)
    }

    async function deleteConfig(){
        setLoading(true)
        await deleteConfigAPI(deleteConfigOpen)
        await getServersList()
        setLoading(false)
        setDeleteConfigOpen(null)
    }

    const isVipUser =
        client?.premium === true || String(client?.tariff_name || '').toUpperCase() === 'VIP';

    function getImage(country){
        switch (country){
            case 'Нидерланды':
                return nid
            case 'Италия':
                return itali
            case 'Польша':
                return polsh
            case 'Казахстан':
                return kaz
            case 'Латвия':
                return latvia
            case 'Турция':
                return tur
            case 'Россия':
                return rus
            case 'США':
                return usa
            case 'Япония':
                return japan
            case 'Испания':
                return spain
            case 'Франция':
                return france
            case 'Германия':
                return germany
            default:
                return null
        }
    }

    return (
        <div className={classes._}>
            <Header client={client} getClient={getClient} openAddBalance={openAddBalance} setOpenAddBalance={setOpenAddBalance}/>
            <div className={classes.subCard}>
                <div className={classes.subCardMain}>
                    <div className={classes.subIconWrap} aria-hidden="true">
                        <img src={vless} alt="" className={classes.subIcon}/>
                    </div>
                    <div className={classes.subText}>
                        <div className={classes.subTitle}>VLESS-подписка</div>
                        <div className={classes.subMeta}>
                            {vpnSub?.exists
                                ? 'Одна ссылка · РФ напрямую · зарубежье через VPN'
                                : 'Получите постоянную ссылку подписки'}
                        </div>
                        {Array.isArray(vpnSub?.locations) && vpnSub.locations.length ? (
                            <div className={classes.subLocations}>
                                {vpnSub.locations.map((x, i) => {
                                    const name = x.country || x.name;
                                    if (!name) return null;
                                    const flag = getImage(name);
                                    return (
                                        <span className={classes.subLocChip} key={`${name}-${i}`}>
                                            {flag ? (
                                                <img className={classes.subLocFlag} src={flag} alt=""/>
                                            ) : null}
                                            {name}
                                        </span>
                                    );
                                })}
                            </div>
                        ) : null}
                    </div>
                </div>
                <div className={classes.subActions}>
                    {!vpnSub?.exists ? (
                        <button
                            type="button"
                            className={classes.subBtn}
                            disabled={subBusy}
                            onClick={onEnsureVless}
                        >
                            VLESS
                        </button>
                    ) : (
                        <button
                            type="button"
                            className={classes.subBtn}
                            disabled={subBusy}
                            onClick={onCopyVless}
                        >
                            Скопировать
                        </button>
                    )}
                </div>
            </div>
            {myServers.length < 6 && (
                <button
                    type="button"
                    className={classes.addServerTopBtn}
                    onClick={() => setOpenServers(true)}
                >
                    Добавить VPN-сервер
                </button>
            )}
            <div className={classes.servers}>
                {myServers.map(item=>
                    <div className={classes.server} key={item.name}>
                        <div className={classes.serverBlock}>
                            <div className={classes.serverImage}>
                                <img src={getImage(item.server.country)} alt={''} className={classes.serverImageIMG}/>
                                {item.server.client === 'Wireguard' &&
                                    <img src={wireguard} alt={''} className={classes.serverClient}/>
                                }
                                {item.server.client === 'AmneziaWG' &&
                                    <img src={amneziaWG} alt={''} className={classes.serverClient}/>
                                }
                                {item.server.client.split(' ')[0] === 'VLESS' &&
                                    <>
                                        <div className={classes.serverClientText}>{item.server.client.split(' ')[1]}</div>
                                        <img src={vless} alt={''} className={classes.serverClient} style={{width:'48px',left: '25px'}}/>
                                    </>
                                }
                            </div>
                            <div className={classes.serverName}>
                                {item.name.replace('awg_','')}
                                {item.server?.is_premium ? <span className={classes.premiumTag}>Premium</span> : null}
                            </div>
                        </div>
                        <div className={classes.serverBlock2}>
                            <svg onClick={async ()=>getConfig(item.name)} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="20" cy="20" r="19.5" stroke="#FFF"/>
                                <g clipPath="url(#clip0_215_638)">
                                    <path d="M27.5129 19.3034C27.2424 19.3034 27.0259 19.5199 27.0259 19.7905V24.2209C27.0259 25.4259 26.0446 26.4036 24.8432 26.4036H14.1568C12.9518 26.4036 11.9741 25.4223 11.9741 24.2209V19.7183C11.9741 19.4477 11.7576 19.2313 11.4871 19.2313C11.2165 19.2313 11 19.4477 11 19.7183V24.2209C11 25.9634 12.4179 27.3777 14.1568 27.3777H24.8432C26.5857 27.3777 28 25.9598 28 24.2209V19.7905C28 19.5235 27.7835 19.3034 27.5129 19.3034Z" fill="#FFF"/>
                                    <path d="M19.1571 23.5101C19.2509 23.6039 19.3771 23.6544 19.4998 23.6544C19.6225 23.6544 19.7488 23.6075 19.8426 23.5101L22.9381 20.4146C23.1293 20.2234 23.1293 19.9167 22.9381 19.7255C22.7468 19.5343 22.4402 19.5343 22.249 19.7255L19.9869 21.9912V12.1094C19.9869 11.8388 19.7704 11.6224 19.4998 11.6224C19.2292 11.6224 19.0128 11.8388 19.0128 12.1094V21.9912L16.7471 19.7255C16.5558 19.5343 16.2492 19.5343 16.058 19.7255C15.8667 19.9167 15.8667 20.2234 16.058 20.4146L19.1571 23.5101Z" fill="#FFF"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_215_638">
                                        <rect width="17" height="17" fill="white" transform="translate(11 11)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <svg onClick={()=>setDeleteConfigOpen(item)} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="20" cy="20" r="19.5" stroke="#FFF"/>
                                <path d="M20 24.375C19.8342 24.375 19.6753 24.3092 19.5581 24.1919C19.4408 24.0747 19.375 23.9158 19.375 23.75V17.5C19.375 17.3342 19.4408 17.1753 19.5581 17.0581C19.6753 16.9408 19.8342 16.875 20 16.875C20.1658 16.875 20.3247 16.9408 20.4419 17.0581C20.5592 17.1753 20.625 17.3342 20.625 17.5V23.75C20.625 23.9158 20.5592 24.0747 20.4419 24.1919C20.3247 24.3092 20.1658 24.375 20 24.375ZM25.625 16.25C25.4592 16.25 25.3003 16.3158 25.1831 16.4331C25.0658 16.5503 25 16.7092 25 16.875V24.0813C25 24.988 24.6398 25.8575 23.9987 26.4987C23.3575 27.1398 22.488 27.5 21.5813 27.5H18.4188C17.512 27.5 16.6425 27.1398 16.0013 26.4987C15.3602 25.8575 15 24.988 15 24.0813V16.875C15 16.7092 14.9342 16.5503 14.8169 16.4331C14.6997 16.3158 14.5408 16.25 14.375 16.25C14.2092 16.25 14.0503 16.3158 13.9331 16.4331C13.8158 16.5503 13.75 16.7092 13.75 16.875V24.0813C13.7517 25.319 14.2441 26.5055 15.1193 27.3807C15.9945 28.2559 17.181 28.7483 18.4188 28.75H21.5813C22.819 28.7483 24.0055 28.2559 24.8807 27.3807C25.7559 26.5055 26.2483 25.319 26.25 24.0813V16.875C26.25 16.7092 26.1842 16.5503 26.0669 16.4331C25.9497 16.3158 25.7908 16.25 25.625 16.25ZM18.125 23.75V17.5C18.125 17.3342 18.0592 17.1753 17.9419 17.0581C17.8247 16.9408 17.6658 16.875 17.5 16.875C17.3342 16.875 17.1753 16.9408 17.0581 17.0581C16.9408 17.1753 16.875 17.3342 16.875 17.5V23.75C16.875 23.9158 16.9408 24.0747 17.0581 24.1919C17.1753 24.3092 17.3342 24.375 17.5 24.375C17.6658 24.375 17.8247 24.3092 17.9419 24.1919C18.0592 24.0747 18.125 23.9158 18.125 23.75ZM27.5 14.375C27.5 14.5408 27.4342 14.6997 27.3169 14.8169C27.1997 14.9342 27.0408 15 26.875 15H13.125C12.9592 15 12.8003 14.9342 12.6831 14.8169C12.5658 14.6997 12.5 14.5408 12.5 14.375C12.5 14.2092 12.5658 14.0503 12.6831 13.9331C12.8003 13.8158 12.9592 13.75 13.125 13.75H16.875C16.875 13.087 17.1384 12.4511 17.6072 11.9822C18.0761 11.5134 18.712 11.25 19.375 11.25H20.625C21.288 11.25 21.9239 11.5134 22.3928 11.9822C22.8616 12.4511 23.125 13.087 23.125 13.75H26.875C27.0408 13.75 27.1997 13.8158 27.3169 13.9331C27.4342 14.0503 27.5 14.2092 27.5 14.375ZM21.875 13.75C21.875 13.4185 21.7433 13.1005 21.5089 12.8661C21.2745 12.6317 20.9565 12.5 20.625 12.5H19.375C19.0435 12.5 18.7255 12.6317 18.4911 12.8661C18.2567 13.1005 18.125 13.4185 18.125 13.75H21.875ZM23.125 23.75V17.5C23.125 17.3342 23.0592 17.1753 22.9419 17.0581C22.8247 16.9408 22.6658 16.875 22.5 16.875C22.3342 16.875 22.1753 16.9408 22.0581 17.0581C21.9408 17.1753 21.875 17.3342 21.875 17.5V23.75C21.875 23.9158 21.9408 24.0747 22.0581 24.1919C22.1753 24.3092 22.3342 24.375 22.5 24.375C22.6658 24.375 22.8247 24.3092 22.9419 24.1919C23.0592 24.0747 23.125 23.9158 23.125 23.75Z" fill="#FFF"/>
                            </svg>
                        </div>
                    </div>)
                }
            </div>
            <CSSTransition in={openServers}
                           timeout={300}
                           classNames="openBlock"
                           unmountOnExit>
                <div className={classes.fon} onClick={()=>setOpenServers(false)}></div>
            </CSSTransition>
            <CSSTransition in={openServers}
                           timeout={300}
                           classNames="openBonusMenu"
                           unmountOnExit>
                <div className={classes.servers2Block}>
                    {myServers.length === 3 && !isVipUser ? (
                        <div className={classes.proTariffHint}>
                            {String(client?.tariff_name || '') === 'Legacy'
                                ? 'Ваш тариф будет переведён на тариф Pro: до 6 серверов, 6₽/сут (180₽/мес). Если у вас снова будет менее 4 серверов, тариф снова вернётся к прежнему'
                                : 'Ваш тариф будет переведён на тариф Pro: до 6 серверов, 10₽/сут (300₽/мес). Если у вас снова будет менее 4 серверов, тариф снова вернётся к прежнему'}
                        </div>
                    ) : null}
                    <div className={classes.servers2}>
                        {selectedServer?.map((item, number)=>
                            <div className={classes.server} key={number} onClick={async ()=>newConfig(item)}>
                                <div className={classes.serverBlock}>
                                    <div className={classes.serverImage}>
                                        <img src={getImage(item.name)} alt={''} className={classes.serverImageIMG}/>
                                    </div>
                                    <div className={classes.serverName}>
                                        {item.name}{' '}
                                        {item.is_premium ? <span className={classes.premiumTagInline}>Premium</span> : null}
                                        {item.client!=='AmneziaWG' && item.client ? ` ${item.client}` : null}
                                    </div>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                    <circle cx="20" cy="20" r="19.5" stroke="#FFF"/>
                                    <path d="M13 26L26 13M26 13H17.4828M26 13V21.069" stroke="#FFF" strokeWidth="2"/>
                                </svg>
                            </div>)
                        }
                    </div>
                    <div className={classes.platforms}>
                        <div className={classes.platform+' '+(selectPlatform===0 && classes.platformActive)} style={{borderRadius:'10px 0 0 10px', borderRight:'1px solid #555'}} onClick={()=>setSelectPlatform(0)}>AmneziaWG</div>
                        <div className={classes.platform+' '+(selectPlatform===1 && classes.platformActive)} style={{borderRadius:'0 10px 10px 0'}} onClick={()=>setSelectPlatform(1)}>Wireguard</div>
                    </div>
                </div>
            </CSSTransition>

            {premiumConfirmOpen && premiumConfirmOpt ? (
                <CSSTransition
                    in={premiumConfirmOpen}
                    timeout={300}
                    classNames="openBlock"
                    unmountOnExit
                >
                    <div className={classes.premiumModal}>
                        <div
                            className={classes.fon}
                            onClick={() => setPremiumConfirmOpen(false)}
                        ></div>
                        <div className={classes.premiumModalCard}>
                            <button
                                type="button"
                                className={classes.premiumClose}
                                aria-label="Закрыть"
                                onClick={() => setPremiumConfirmOpen(false)}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none">
                                    <path d="M18 6L6 18M18 18L6 6" stroke="#FFF" strokeWidth="2" strokeLinecap="round"/>
                                </svg>
                            </button>

                            <div className={classes.premiumModalBody}>
                                <div className={classes.premiumModalTitle}>
                                    Premium-конфиг: правила и стоимость
                                </div>
                                <p className={classes.premiumModalLead}>
                                    Пожалуйста, подтвердите, что вы понимаете условия Premium-конфигурации:
                                </p>

                                <div className={classes.premiumSection}>
                                    <div className={classes.premiumSectionTitle}>Лимит на сервер</div>
                                    <p>
                                        На каждый Premium-сервер мы допускаем не более 3 человек. Это сделано, чтобы снизить шанс перегрузки и блокировки сервера.
                                    </p>
                                </div>

                                <div className={classes.premiumSection}>
                                    <div className={classes.premiumSectionTitle}>Стоимость</div>
                                    <p>
                                        После создания этого Premium-конфига с вашего баланса будет списываться 33₽ в день (≈ 1000₽ в месяц) за каждый Premium-конфиг.
                                        Если вы удалите его, то тариф станет прежним.
                                    </p>
                                </div>

                                <div className={classes.premiumSection}>
                                    <div className={classes.premiumSectionTitle}>Правила безопасности (очень важно)</div>
                                    <p>
                                        С этого Premium-конфига крайне не рекомендуется заходить на:
                                    </p>
                                    <ul className={classes.premiumList}>
                                        <li>Госуслуги</li>
                                        <li>Max</li>
                                        <li>и любые сервисы, которые просят выключить VPN</li>
                                    </ul>
                                </div>
                            </div>

                            <div className={classes.premiumModalActions}>
                                <button
                                    type="button"
                                    className={classes.premiumConfirmBtn}
                                    onClick={confirmPremiumConfig}
                                >
                                    Подтверждаю и создать Premium-конфиг
                                </button>
                                <button
                                    type="button"
                                    className={classes.premiumCancelBtn}
                                    onClick={() => setPremiumConfirmOpen(false)}
                                >
                                    Отмена
                                </button>
                            </div>
                        </div>
                    </div>
                </CSSTransition>
            ) : null}

            <CSSTransition in={deleteConfigOpen}
                           timeout={300}
                           classNames="openBlock"
                           unmountOnExit>
                <div className={classes.delete}>
                    <div className={classes.fon} onClick={()=>{setDeleteConfigOpen(null)}}></div>
                    <div className={classes.deleteBlock}>
                        <div className={classes.close} onClick={()=>{setDeleteConfigOpen(null)}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M18 6L6 18M18 18L6 6" stroke="#FFF" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <div className={classes.deleteText}>удалить<br/>сервер?</div>
                        <div className={classes.deleteButton} onClick={deleteConfig}>Удалить</div>
                        <div className={classes.deleteButton+' '+classes.deleteButton2} onClick={()=>{setDeleteConfigOpen(null)}}>Отмена</div>
                    </div>
                </div>
            </CSSTransition>

            {!!notification && <div className={classes.notification}>{notification}</div>}
            <Loading isOpen={loading}/>
        </div>
    );
};

export default Vpn;